import Vue from 'vue'
import Store from '@/search/store'
import App from '@/search/App.vue'
import { Blue } from '!/js/core';
import VueMoment from 'vue-moment';

Vue.config.devtools = true
Vue.config.productionTip = false

const props = {};
const util = new Blue(props);

util.ready('mount_search', '[vue-search]', el => {
	const queryText = el.getAttribute('vue-search')

	Vue.use(VueMoment);
	

	const app = new Vue({
		store: new Store,
		render: h => h(App,
			{
				props: {
					queryText: queryText
				}
			})
	});
	app.$mount(el)
})

/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> vue/src folder root
-----------------------------*/